export const cert_data = [
    {
      id: 1,
      img: 'pre_incub.jpg',
      awarder_on: 'December 28 2023',
      level: 'Incubator',
      title: 'Edutech Incubator Helsinki Batch 5',
      download_icon:"pdf.png",
      download_url:"https://res.cloudinary.com/dk4ruyonq/image/upload/v1706649002/Ujuzi_fa3a3ea4ec.jpg",
      lesson: 13,
      student: 28,
      short_desc:"We Embark on Edutech entrepreneurial journey with the Helsinki Edutech Accelerator, where we were guided on how to build robust businesses aligned with the high standards of Helsinki startups, ensuring both innovation and pedagogical excellence",
      features: [
        'Build fully-fledged business.',
        'Adhere to quality and standard of Helsinki startup.',
        'Ensure Pendagogical standards are achieved.'
      ], 
      social_links:[
        {link: 'http://facebook.com', target: '_blank', icon: 'icon-facebook'},
        {link: 'https://www.linkedin.com/', target: '_blank', icon: 'icon-linkedin2'},
      ],
    },
    {
      id: 2,
      img: 'incub.png',
      awarder_on: 'December 14 2023',
      level: 'Pre-Incubator',
      title: 'Saro/Fracture pre - Incubation Programme',
      download_icon:"pic.png",
      download_url:"https://res.cloudinary.com/dk4ruyonq/image/upload/v1706648814/1963_001_74b97f4be9.pdf",
      lesson: 15,
      student: 35,
      short_desc:"We Embark on Edutech entrepreneurial journey with the Helsinki Edutech Accelerator, where we were guided on how to build robust businesses aligned with the high standards of Helsinki startups, ensuring both innovation and pedagogical excellence",
      features: [
        'High standards, both in terms of general business practices',
        'Collaboration with educational experts for validation .',
        'Access to networks and resources associated with Helsinki startup ecosystem.'
      ], 
      social_links:[
        {link: 'http://facebook.com', target: '_blank', icon: 'icon-facebook'},
        {link: 'https://www.linkedin.com/', target: '_blank', icon: 'icon-linkedin2'},
      ],

    },
    {
      id: 2,
      img: 'boniphace_certs.png',
      awarder_on: 'December 14 2023',
      level: 'Team',
      title: 'Founder Certification',
      download_icon:"pic.png",
      download_url:"https://res.cloudinary.com/dk4ruyonq/image/upload/v1707425407/Boniphace_CV_bed98303aa.pdf",
      lesson: 15,
      student: 35,
      short_desc:"To ensure excellence, our foundation is equipped with the requisite knowledge, experience, and tools, ensuring that the quality delivered is of the highest standard",
      features: [
        'Expertise: Our foundation boasts extensive expertise, guaranteeing excellence in every endeavor.',
        'Experience: With a wealth of experience, we navigate challenges adeptly, ensuring top-notch quality.',
        'Tools: Equipped with cutting-edge tools, our foundation is primed for delivering excellence at all levels.'
      ], 
      social_links:[
        {link: 'http://facebook.com', target: '_blank', icon: 'icon-facebook'},
        {link: 'https://www.linkedin.com/', target: '_blank', icon: 'icon-linkedin2'},
      ],

    },
]